export const getDisabledIds = (state) => state.deviceAccessRules.disabledIds;
export const getErrors = (state) => state.deviceAccessRules.errors;
export const getIsFetching = (state) => state.deviceAccessRules.isFetching;
export const getIsRefreshing = (state) => state.deviceAccessRules.isRefreshing;
export const getItems = (state) => state.deviceAccessRules.items;
